<template>
  <div class="pager">
    <nav aria-label="Page navigation example">
      <ul class="pagination pagination-sm justify-content-center">
        <li class="page-item">
          <a
            class="page-link"
            href="#"
            aria-label="Previous"
            @click.prevent="handleClickPage(page-1)"
            v-if="(page-1)>0"
          >
            <span aria-hidden="true">&laquo;</span>
            <span class="sr-only">Previous</span>
          </a>
        </li>
        <li class="page-item">
          <a class="page-link" href="#" @click.prevent="handleClickPage(1)">首</a>
        </li>
        <li class="page-item" v-for="p in pages" :key="p" :class="{active:p==page}">
          <a class="page-link" href="#" @click.prevent="handleClickPage(p)">{{p}}</a>
        </li>
        <li class="page-item">
          <a class="page-link" href="#" @click.prevent="handleClickPage(totalPage)">尾</a>
        </li>
        <li class="page-item">
          <a
            class="page-link"
            href="#"
            aria-label="Next"
            @click.prevent="handleClickPage(page+1)"
            v-if="(page+1)<=totalPage"
          >
            <span aria-hidden="true">&raquo;</span>
            <span class="sr-only">Next</span>
          </a>
        </li>
      </ul>
    </nav>
    <div class="input-group mb-3 justify-content-center">
      <input
        v-model.number="gotoPage"
        type="number"
        class="jump"
        placeholder="goto page"
        aria-label="goto page"
        aria-describedby="basic-addon2"
        @keydown.enter="handleClickJump"
      />
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" type="button" @click="handleClickJump">跳转</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pager",
  props: {
    page: Number,
    totalPage: Number
  },
  data: function() {
    return {
      gotoPage: 0
    };
  },
  computed: {
    pages: function() {
      var pages = [];
      for (let index = this.page - 2; index <= this.page + 2; index++) {
        if (index > 0 && index <= this.totalPage) {
          pages.push(index);
        }
      }
      return pages;
    }
  },
  methods: {
    handleClickPage(p) {
      if (p!=this.page) {
        this.$emit("changePage", p);
      }
    },
    handleClickJump(){
      if (!this.gotoPage) {
        this.gotoPage=Math.floor(Math.random()*this.totalPage)+1;
      }
      this.$emit("changePage",this.gotoPage);
      this.gotoPage=0;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pager {
  margin-top:20px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
a {
  color: #42b983;
}
</style>
